import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Configuration } from '../configuration';
import { PhonePrefixes } from '../models/phonePrefixes.model';

@Injectable({
  providedIn: 'root'
})
export class PhonePrefixesService {
  public configuration = new Configuration();
  baseUrl: string;
  apiEndpoint: string = 'PhonePrefixes/';

  constructor(private http: HttpClient, configuration: Configuration) {
    this.baseUrl = configuration.apiBasePath ?? '';
  }

  public getPhonePrefixes(): Observable<Array<PhonePrefixes>> {
    const requestUrl = `${this.baseUrl}${this.apiEndpoint}`;
    return this.http.get<Array<PhonePrefixes>>(requestUrl);
  }
}
